module.exports = __webpack_public_path__ + "img/zhuanpan-zhizhen-gray.f8bfd5f3.png";